import { useTranslation } from 'react-i18next'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { useWorkItemTypeMutations } from '@/lib/db/rxdb/hooks/entities/work-item-types'

interface DeleteWorkItemTypeDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  typeId: string | null
  typeName: string
}

export function DeleteWorkItemTypeDialog({
  open,
  onOpenChange,
  typeId,
  typeName,
}: DeleteWorkItemTypeDialogProps) {
  const { t } = useTranslation('settings')
  const { t: tCommon } = useTranslation('common')
  const { deleteWorkItemType } = useWorkItemTypeMutations()

  const handleDelete = async () => {
    if (!typeId) return
    try {
      await deleteWorkItemType(typeId)
      onOpenChange(false)
    } catch {
      // TODO: Show error toast
    }
  }

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('workItemTypes.deleteDialog.title')}</AlertDialogTitle>
          <AlertDialogDescription>
            {t('workItemTypes.deleteDialog.description', { name: typeName })}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{tCommon('actions.cancel')}</AlertDialogCancel>
          <AlertDialogAction
            onClick={handleDelete}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {tCommon('actions.delete')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
